export default __webpack_public_path__ + "static/media/ncsa-logo-full-color.faa15f79.png";